import { KPI_ACCENTS, KPI_CARD_CLASS } from "../styles";
import type { KpiItem } from "../types";

type Props = {
  items: KpiItem[];
};

export default function KpiSection({ items }: Props) {
  return (
    <section
      className="grid gap-4"
      style={{ gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))" }}
    >
      {items.map((item) => (
        <div key={item.label} className={[KPI_CARD_CLASS, "relative overflow-hidden"].join(" ")}>
          <div
            className={[
              "absolute left-5 right-5 top-4 h-1 rounded-full bg-gradient-to-r",
              KPI_ACCENTS[item.accent ?? "slate"].gradient,
            ].join(" ")}
          />
          <div className="flex items-center gap-2 pt-3 text-xs font-semibold uppercase tracking-wide text-slate-400">
            <span className={["h-2 w-2 rounded-full", KPI_ACCENTS[item.accent ?? "slate"].dot].join(" ")} />
            {item.label}
          </div>
          {item.value && (
            <div className="mt-2 flex flex-wrap items-baseline gap-2">
              <span className={["text-2xl font-semibold text-slate-900", item.tone ?? ""].join(" ")}>
                {item.value}
              </span>
              {item.suffix && (
                <span className={["text-sm font-semibold", item.tone ?? "text-slate-500"].join(" ")}>
                  {item.suffix}
                </span>
              )}
            </div>
          )}
          {item.badges && (
            <div className="mt-3 flex flex-wrap gap-2">
              {item.badges.map((badge) => (
                <span
                  key={badge.label}
                  className={[
                    "inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold",
                    badge.className,
                  ].join(" ")}
                >
                  {badge.icon}
                  {badge.label}
                </span>
              ))}
            </div>
          )}
          {item.description && <p className="mt-2 text-xs text-slate-500">{item.description}</p>}
        </div>
      ))}
    </section>
  );
}
